























import Vue from "vue";
import ForwardButton from "../components/ForwardButton.vue";

export default Vue.extend({
  name: "Greetings",
  components: {
    ForwardButton: ForwardButton
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onConfirmationClick: function() {
      console.log("I AM SURE");
    },
    onBackClick: function() {
      this.$emit("back-click");
    }
  }
});
